import styled from "styled-components"

export const GlobalConfigContainer = styled.div`
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    width: 80%;    

    .print-stage {
        margin: -15px -15px 0px -10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .row {
        display: flex;
        justify-content: space-between;
    }

    .selectImageBackup {
        height: 70px; 
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
    }

    .row > div {
        display: flex;
        align-items: center;
    }

    .MuiSwitch {
        background-color: #68498C;
    }

    .MuiSwitch-track {
        background-color: #68498C !important;
    }

    .MuiSwitch-thumb, .Mui-checked {
        color: #68498C !important;
    }

    @media (min-width: 1280px) and (max-width: 1359px) {

    .row {
        flex-direction: column;
        margin: -15px 0 0 -5px;
    }

    .switch {
        margin: -35px 0 5px 0;
    }

    .print-stage {
        display: flex;
        flex-direction: column;
        padding: 10px 0 0 0;
        margin: -15px 0 0 -5px;
    }
  }

  @media (min-width: 1360px) and (max-width: 1439px) {

    .row {
        flex-direction: column;
        margin: -15px 0 0 -5px;
    }

    .switch {
        margin: -35px 0 5px 0;
    }

    .print-stage {
        display: flex;
        flex-direction: column;
        padding: 10px 0 0 0;
        margin: -15px 0 0 -5px;
    }
}

@media (min-width: 1440px) and (max-width: 1599px) {

    .row {
        flex-direction: column;
        margin: -15px 0 0 -9px;
    }

    .switch {
        margin: -35px 0 5px 0;
    }

    .print-stage {
        display: flex;
        flex-direction: column;
        padding: 10px 0 0 0;
        margin: -15px 0 0 -9px;
    }
}

@media (min-width: 1600px) and (max-width: 1919px) {

    .row {
        flex-direction: column;
        margin: -15px 0 0 -14px;
    }

    .switch {
        margin: -35px 0 5px 0;
    }

    .print-stage {
        display: flex;
        flex-direction: column;
        padding: 10px 0 0 0;
        margin: -15px 0 0 -14px;
    }
}

@media (min-width: 1920px) and (max-width: 2559px) {

    .row {
        margin: -5px 0 0 -10px;
    }
}
`;
